// Get a computed style (ignoring inline values)
// --------------------------------------------------

function getInitialStyle(selector, property) {
	const el = document.querySelector(selector);
	const inlineStyles = el.getAttribute('style');

	el.removeAttribute('style');

	const initialStyle = getComputedStyle(el)[property];

	el.setAttribute('style', inlineStyles);

	return initialStyle;
}